module.exports = function getResource(label, vars = []) {
    const resources = {
        addNewCard: 'Ajouter une nouvelle carte',
        cancel: 'Annuler',
        completeBooking: 'Compléter la réservation',
        creditCardRequiredInfo: 'Une carte de crédit est requise pour garantir cette réservation.',
        cvc: 'CVV/CVC',
        default: 'Carte par défaut',
        deleteCreditCardDialogMessage: 'Êtes-vous sûr de vouloir supprimer cette carte de façon définitive?',
        deleteCreditCardDialogOkButtonText: 'Supprimer',
        deleteCreditCardDialogTitle: 'Supprimer la carte de crédit',
        edit: 'Modifier',
        expiredCreditCardMsg: 'Cette carte est expirée. Veuillez le mettre à jour ou utiliser une autre carte.',
        expires: `Expire le : ${vars[0]}/${vars[1]}`,
        minutes: 'Min',
        modalTitle: 'Détails de la réservation',
        paymentMethod: 'Mode de paiement',
        remove: 'Supprimer',
        saveAndContinue: 'Enregistrer et continuer',
        updateSecurityCode: 'Veuillez saisir votre code de sécurité.',
        virtual: 'Services virtuels',
        endingIn: 'se terminant par'
    };

    return resources[label];
};
